import {
  SwipeDirection,
  SwipeAxis,
  SwipeEndInfo,
  SwipeUpdateInfo,
  SwipeConfig,
  SwipeEvents,
} from './Swipe.model';

export type {
  SwipeDirection,
  SwipeAxis,
  SwipeEndInfo,
  SwipeUpdateInfo,
  SwipeConfig,
  SwipeEvents,
};

export const DEFAULT_SWIPE_CONFIG: Required<SwipeConfig> = {
  threshold: 0.2,
  duration: 0.1,
  dragElastic: 0.5,
  direction: 'x',
  enabled: true,
  dragConstraints: { left: 0, right: 0 },
  dragDirectionLock: true,
};

export const swipeVariants = {
  initial: { x: 0, y: 0 },
  animate: { x: 0, y: 0 },
  exit: { opacity: 0 },
};

export const mergeSwipeConfig = (
  customConfig?: Partial<SwipeConfig>
): Required<SwipeConfig> => {
  const merged = {
    ...DEFAULT_SWIPE_CONFIG,
    ...customConfig,
  };

  if (!customConfig?.dragConstraints) {
    if (merged.direction === 'x') {
      merged.dragConstraints = { left: 0, right: 0 };
    } else if (merged.direction === 'y') {
      merged.dragConstraints = { top: 0, bottom: 0 };
    } else {
      merged.dragConstraints = { left: 0, right: 0, top: 0, bottom: 0 };
    }
  }

  return merged;
};

export const calculateSwipeDirection = (x: number, y: number, axis: SwipeAxis): SwipeDirection => {
  if (axis === 'x') {
    return x > 0 ? 'right' : 'left';
  } else if (axis === 'y') {
    return y > 0 ? 'down' : 'up';
  } else {
    const absX = Math.abs(x);
    const absY = Math.abs(y);
    if (absX > absY) {
      return x > 0 ? 'right' : 'left';
    } else {
      return y > 0 ? 'down' : 'up';
    }
  }
};

export const calculateSwipeProgress = (
  offset: number,
  threshold: number,
  screenSize: number
): number => {
  const thresholdPx = screenSize * threshold;
  return Math.min(Math.abs(offset) / thresholdPx, 1);
};
